
import { Options } from "vue-class-component";
import { ScreenType } from "../../../enum/screen.type";
import Base from "../../../components/base/Base.vue";
import Rules from "../../../components/ListRules/Rules/Rules.vue";
import RouterService from "../../../services/router.service";
import LayoutService from "../../../services/layout.service";
@Options({
  components: {
    Rules
  }
})
export default class RoomList extends Base {
  room = null;
  keySearch = null;
  created() {
    LayoutService.setDialog({ show: false, name: "EnterPin" });
  }
  rooms = [
    {
      roomId: 123,
      host: "Izi_Best",
      hostLevel: "Biology Master",
      members: "5/10",
      status: "Waiting"
    },
    {
      roomId: 456,
      host: "Zoro",
      hostLevel: "Blade Master",
      members: "5/10",
      status: "Waiting"
    }
  ];

  selectRoom(room: object) {
    LayoutService.setDialog({
      show: true,
      name: "EnterPin",
      data: room,
      modal: true
    });
  }

  cancel() {
    RouterService.redirectTo(ScreenType.hall);
  }
  configPage = {
    left: {
      xl: "2",
      lg: "",
      md: "",
      col: "12",
      fixed: false,
      show: true
    },
    center: {
      xl: "7",
      lg: "",
      md: "",
      col: "12"
    },
    right: {
      xl: "3",
      lg: "",
      md: "",
      col: "12",
      fixed: false,
      show: true
    }
  };
}
